import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { PersonService } from 'services/api/person.service';
import { selectPersonalDetails } from 'stores/personal/personal.selectors';
import { setDropOffState } from 'shared/base/generics/store/drop-off/drop-off.actions';
import { requestFailure } from 'shared/base/generics/store/error/error.actions';
import { Injectable } from '@angular/core';
import {
    checkAnonymousContactValidityRequest,
    checkAnonymousContactValidityResponse,
    checkContactValidityRequest,
    checkContactValidityResponse,
} from './quote-config.actions';

@Injectable({ providedIn: 'any' })
export class QuoteConfigEffects {
    constructor(
        private actions$: Actions,
        private store$: Store,
        private personalService$: PersonService,
    ) {}

    contactNumberValidityRequest = createEffect(() =>
        this.actions$.pipe(
            ofType(checkContactValidityRequest),
            withLatestFrom(this.store$.select(selectPersonalDetails)),
            mergeMap(([action, personalDetails]) => {
                return this.personalService$
                    .checkContactValidity(personalDetails.policyHolder?.phone)
                    .pipe(
                        map((response) => {
                            setDropOffState({
                                dropOffState: response,
                            });
                            return checkContactValidityResponse({ dropOffState: response });
                        }),
                        catchError((error) => of(requestFailure(error))),
                    );
            }),
        ),
    );

    anonymousContactNumberValidityRequest = createEffect(() =>
        this.actions$.pipe(
            ofType(checkAnonymousContactValidityRequest),
            mergeMap((action) => {
                return this.personalService$
                    .checkAnonymousContactValidity(action.contactNumber)
                    .pipe(
                        map((response) => {
                            setDropOffState({
                                dropOffState: response,
                            });
                            return checkAnonymousContactValidityResponse({
                                dropOffState: response,
                            });
                        }),
                        catchError((error) => of(requestFailure(error))),
                    );
            }),
        ),
    );
}
